// src/pages/gt3x/Register.jsx
import { useState } from "react";
import PageHero from "../../components/PageHero.jsx";
import { APPS_SCRIPT_URL as SCRIPT_URL } from "../../lib/appsScript";

const debug = window.location.search.includes("debug=1");

const initialForm = {
    fullName: "",
    iracingName: "",
    iracingId: "",
    teamName: "",
    numberPro: "",
    numberInt: "",
    numberAm: "",
};

export default function RegisterForm() {
    const [form, setForm] = useState(initialForm);
    const [loading, setLoading] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");

    const filledClass = (value) =>
        value && String(value).trim() !== "" ? " reg-input--filled" : "";

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setSuccessMsg("");
        setErrorMsg("");

        try {
            const fd = new FormData();

            Object.entries(form).forEach(([key, value]) => {
                fd.append(key, value);
            });

            const res = await fetch(SCRIPT_URL, {
                method: "POST",
                body: fd,
            });

            if (res.type === "opaque") {
                console.warn("Opaque response (CORS) – nehme Erfolg an.");
                setSuccessMsg(
                    "Hiermit wird deine Anmeldung bestätigt. Vielen Dank – wir prüfen deine Daten und melden uns bei dir!"
                );
                setForm(initialForm);
                setLoading(false);
                return;
            }

            const text = await res.text();
            console.log("Apps Script response raw:", text);

            let json;
            try {
                json = JSON.parse(text);
            } catch {
                throw new Error("Konnte Antwort vom Script nicht als JSON lesen.");
            }

            if (!res.ok || !json.ok) {
                throw new Error(json.error || "Unbekannter Fehler vom Apps Script.");
            }

            setSuccessMsg("Hiermit wird deine Anmeldung bestätigt. Vielen Dank!");
            setForm(initialForm);
        } catch (err) {
            console.error("Fehler bei Anmeldung:", err);
            setErrorMsg(
                "Die Anmeldung konnte nicht gespeichert werden. Bitte probiere es später erneut oder kontaktiere die Orga."
            );
        } finally {
            setLoading(false);
        }
    };

    const labelStyle = {
        alignSelf: "center",
        justifySelf: "flex-end",
        marginRight: "8px",
        fontWeight: 700,
        fontFamily:
            'var(--ff-Kallisto), "Rajdhani", system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial',
        fontSize: "0.95rem",
        letterSpacing: ".02em",
    };

    const fullRow = { gridColumn: "1 / -1" };

    return (
        <div className="rv-page">
            <PageHero
                kicker="GT3 Xperience"
                title="Anmeldung"
            >
                Melde dich für die RaceVision GT3 Xperience an. Bitte trage deine Daten sauber ein,
                besonders deinen exakten iRacing Namen, damit unsere Automatisierungen im Liga Manager korrekt funktionieren.
            </PageHero>

            {debug && (
                <section className="rv-modern-card">
                    <div className="rv-section-head">
                        <div>
                            <div className="rv-section-kicker">Debug</div>
                            <h2>Apps Script Debug</h2>
                        </div>

                        <span className="rv-status-pill rv-status-pill--warn">
                            Debug aktiv
                        </span>
                    </div>

                    <pre
                        style={{
                            fontSize: "12px",
                            padding: "12px",
                            background: "rgba(0,0,0,0.4)",
                            border: "1px solid rgba(228,254,60,.25)",
                            borderRadius: 14,
                            color: "var(--accent)",
                            whiteSpace: "pre-wrap",
                            overflowX: "auto",
                        }}
                    >
                        DEBUG MODE AKTIV{"\n"}
                        Script URL: {SCRIPT_URL}
                        {"\n\n"}Aktueller Form-State: {JSON.stringify(form, null, 2)}
                    </pre>
                </section>
            )}

            {(successMsg || errorMsg) && (
                <section className="rv-modern-card">
                    {successMsg && (
                        <div
                            style={{
                                padding: "12px 14px",
                                borderRadius: 14,
                                border: "1px solid rgba(139,217,166,.45)",
                                background: "rgba(139,217,166,.10)",
                                color: "var(--ok)",
                                fontWeight: 800,
                            }}
                        >
                            {successMsg}
                        </div>
                    )}

                    {errorMsg && (
                        <div
                            style={{
                                padding: "12px 14px",
                                borderRadius: 14,
                                border: "1px solid rgba(255,140,140,.45)",
                                background: "rgba(255,140,140,.10)",
                                color: "var(--err)",
                                fontWeight: 800,
                            }}
                        >
                            {errorMsg}
                        </div>
                    )}

                    {successMsg && (
                        <div style={{ marginTop: 18 }}>
                            <div className="rv-section-head">
                                <div>
                                    <div className="rv-section-kicker">Next Steps</div>
                                    <h2>Nächste Schritte</h2>
                                </div>

                                <span className="rv-status-pill rv-status-pill--ok">
                                    Anmeldung erhalten
                                </span>
                            </div>

                            <ul
                                className="rv-modern-muted"
                                style={{
                                    paddingLeft: "22px",
                                    margin: 0,
                                    fontSize: "0.92rem",
                                }}
                            >
                                <li>Bitte überprüfe, ob du unserem Discord-Server bereits beigetreten bist.</li>
                                <li>
                                    Die Startgebühr beträgt 10 €. Bezahlbar via Paypal: race@racevision.info
                                    über die Family-&-Friends-Funktion.
                                </li>
                                <li>Zur Vorbereitung kannst du das Regelwerk vollständig durchlesen.</li>
                                <li>
                                    Wenn du dich <strong>vor der Saison</strong> anmeldest:
                                    Quali-Events, Ablauf und Server-Infos findest du im Bereich GT3X → Overview.
                                </li>
                                <li>
                                    Wenn du dich <strong>während der Saison</strong> anmeldest:
                                    Wir tragen dich zeitnah in die Teilnehmerliste ein und ordnen dich PRO, INT oder AM zu.
                                </li>
                            </ul>
                        </div>
                    )}
                </section>
            )}

            <section className="rv-modern-card rv-modern-card--accent">
                <div className="rv-section-head">
                    <div>
                        <div className="rv-section-kicker">Registration</div>
                        <h2>Fahrerdaten</h2>
                    </div>

                    <div className="rv-pill-row">
                        <span className="rv-status-pill rv-status-pill--info">
                            GT3X
                        </span>
                    </div>
                </div>

                <p className="rv-modern-muted" style={{ marginBottom: 18 }}>
                    Deine Anmeldung wird direkt in unserer Anmeldeliste eingetragen.
                    Im Reiter <strong>Anmeldeliste</strong> kannst du deinen Eintrag anschließend prüfen.
                </p>

                <form
                    onSubmit={handleSubmit}
                    className="reg-grid"
                    style={{
                        marginTop: "16px",
                        display: "grid",
                        gridTemplateColumns: "max(160px, 30%) minmax(0, 1fr)",
                        columnGap: "18px",
                        rowGap: "12px",
                        maxWidth: "820px",
                        width: "100%",
                    }}
                >
                    <label htmlFor="fullName" style={labelStyle}>
                        Vor- und Nachname
                    </label>
                    <input
                        id="fullName"
                        placeholder=" "
                        className={`reg-input${filledClass(form.fullName)}`}
                        type="text"
                        name="fullName"
                        value={form.fullName}
                        onChange={handleChange}
                        required
                    />

                    <label htmlFor="iracingName" style={labelStyle}>
                        exakter iRacing Name
                    </label>
                    <input
                        id="iracingName"
                        className={`reg-input${filledClass(form.iracingName)}`}
                        type="text"
                        name="iracingName"
                        value={form.iracingName}
                        onChange={handleChange}
                        placeholder="Max Mustermann2"
                        required
                    />

                    <label htmlFor="iracingId" style={labelStyle}>
                        iRacing ID
                    </label>
                    <input
                        id="iracingId"
                        placeholder=" "
                        className={`reg-input${filledClass(form.iracingId)}`}
                        type="text"
                        name="iracingId"
                        value={form.iracingId}
                        onChange={handleChange}
                        required
                    />

                    <label htmlFor="teamName" style={labelStyle}>
                        Teamname
                    </label>
                    <input
                        id="teamName"
                        placeholder=" "
                        className={`reg-input${filledClass(form.teamName)}`}
                        type="text"
                        name="teamName"
                        value={form.teamName}
                        onChange={handleChange}
                    />

                    <label htmlFor="numberPro" style={labelStyle}>
                        Startnummer PRO
                    </label>
                    <input
                        id="numberPro"
                        placeholder="2-99"
                        className={`reg-input${filledClass(form.numberPro)}`}
                        type="text"
                        name="numberPro"
                        value={form.numberPro}
                        onChange={handleChange}
                    />

                    <label htmlFor="numberInt" style={labelStyle}>
                        Startnummer INT
                    </label>
                    <input
                        id="numberInt"
                        placeholder="100-499"
                        className={`reg-input${filledClass(form.numberInt)}`}
                        type="text"
                        name="numberInt"
                        value={form.numberInt}
                        onChange={handleChange}
                    />

                    <label htmlFor="numberAm" style={labelStyle}>
                        Startnummer AM
                    </label>
                    <input
                        id="numberAm"
                        placeholder="500-999"
                        className={`reg-input${filledClass(form.numberAm)}`}
                        type="text"
                        name="numberAm"
                        value={form.numberAm}
                        onChange={handleChange}
                    />

                    <div
                        style={{
                            ...fullRow,
                            display: "flex",
                            justifyContent: "flex-end",
                            marginTop: "8px",
                        }}
                    >
                        <button
                            className="button button--primary"
                            type="submit"
                            disabled={loading}
                            style={{
                                minWidth: "190px",
                                padding: "11px 18px",
                                fontFamily:
                                    'var(--ff-Kallisto), "Rajdhani", system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial',
                                fontWeight: 800,
                                letterSpacing: ".05em",
                                textTransform: "uppercase",
                                fontSize: "0.9rem",
                            }}
                        >
                            {loading ? "Sende Anmeldung…" : "Anmelden"}
                        </button>
                    </div>
                </form>
            </section>
        </div>
    );
}